module.exports = __webpack_public_path__ + "img/icon_mastercard.018a48f9.png";